import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkClaims'
})
export class CheckClaimsPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
